import { put } from "redux-saga/effects";
import { signOut } from "actions/user";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function* handleNetworkError(e: any): Generator {
    if (
        e.response &&
        e.response.data &&
        e.response.data.error === "UNAUTHENTICATED_ERROR"
    ) {
        yield put(signOut());
    }
}
